import React, { useCallback, useEffect, useState } from 'react'
import { createGlobalStyle } from 'styled-components'
import { Modal } from 'react-responsive-modal'
import { scrollbarSize } from '../util/dom'
import { UpgradeView, SuccessView, launchCheckout } from './plus_components'
import { getLocale } from '../lib/locale'
import { useLang } from '../lib/i18n'
import { trackPurchase } from '../lib/tracking'

const scrollbarWidth = scrollbarSize()

const GlobalModalStyles = createGlobalStyle`
    .plus-modal-overlay {
        background: rgba(1, 1, 1, 0.8);
        animation-duration: 300ms !important;
    }

    .react-responsive-modal-modal.plus-modal {
        border-radius: 12px;
        padding: 2rem 2rem 1.5rem;
        max-width: 530px;
        width: 90vw;
        background: #1a1d23;
    }

    .react-responsive-modal-closeButton {
        z-index: 10;
        &, &:active, &:focus {
            outline: none;
        }
        svg {
            fill: #bababa;
        }
    }

    .react-responsive-modal-width-fix {
        width: calc(100% - ${scrollbarWidth}px);
    }
`

let purchaseTracked = false

const PlusModal = ({ open, onClose, autoCheckout }) => {
    const [purchased, setPurchased] = useState(false)
    const lang = useLang()

    useEffect(() => {
        if (open) {
            setPurchased(false)
            purchaseTracked = false
        }
    }, [open])

    useEffect(() => {
        const handler = (event) => {
            if (event.data?.event === 'Checkout.Success') {
                setPurchased(true)
                if (!purchaseTracked) {
                    purchaseTracked = true
                    const order = event.data?.data?.order?.data
                    const attrs = order?.attributes
                    trackPurchase({
                        value: attrs?.total ? attrs.total / 100 : undefined,
                        currency: attrs?.currency,
                        plan: attrs?.first_order_item?.variant_name?.toLowerCase(),
                        orderId: order?.id,
                    })
                }
            }
        }
        window.addEventListener('message', handler)
        return () => window.removeEventListener('message', handler)
    }, [])

    useEffect(() => {
        if (!open || !autoCheckout) return
        const waitForLS = setInterval(() => {
            if (window.LemonSqueezy) {
                clearInterval(waitForLS)
                launchCheckout(autoCheckout)
            }
        }, 100)
        return () => clearInterval(waitForLS)
    }, [open, autoCheckout])

    const openCheckout = useCallback((url, plan) => (e) => {
        e.preventDefault()
        launchCheckout(plan)
    }, []);

    return <>
        <GlobalModalStyles />
        <Modal
            center
            open={open}
            onClose={onClose}
            classNames={{
                overlay: 'plus-modal-overlay',
                modal: 'plus-modal',
            }}
        >
            {purchased
                ? <SuccessView onClose={onClose} />
                : <UpgradeView onCheckout={openCheckout} locale={getLocale(lang)} />
            }
        </Modal>
    </>
}

export default PlusModal
